<template>
<div>
<v-app-bar
      class="overflow-hidden"
      app
      min-height="60px"
    >
      <div class="align-center mx-auto float-none ml-sm-6">
        <a href="/">
          <v-img
            alt="Kefuri"
            class="shrink mt-1 mb-1 logo-b" 
            contain
            min-width="80"
            src="../assets/logo-kefuri.png"
            width="80"
          />
        </a>
      </div>

        <v-spacer></v-spacer>
        <router-link class="link-menu" to="/">
          <v-btn text @click="top">
            <span class="mr-2">Inicio</span>
          </v-btn>
        </router-link>

        <router-link class="link-menu" to="/Nosotros">
          <v-btn text @click="top">
            <span class="mr-2">Nosotros</span>
          </v-btn>
        </router-link>  

        <router-link class="link-menu" to="/Info">
          <v-btn text @click="top">
            <span class="mr-2">Investigación</span>
          </v-btn>
        </router-link>  

        <router-link class="link-menu" to="/App-kefuri">
          <v-btn text @click="top">
            <span class="mr-2">App</span>
          </v-btn>
        </router-link>  

          <v-btn depressed color="cyan" class=" btn-contact" href="/#contact">
            Contáctanos
          </v-btn>

        <v-app-bar-nav-icon class="menu-xs" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer class="bg-menu-xs" v-model="drawer" temporary app>
      <v-row class="pa-2">
        <v-col cols="12" class="mb-3">
          <v-avatar class="d-block mx-auto" size="150"><v-img contain  src="../assets/logo-xs.png"/></v-avatar>   
        </v-col>
        <v-col class="mb-3">
          <v-list class="">
            <v-list-item>
              <router-link class="" to="/">
                <v-btn text @click="top">
                  <span class="title">Inicio</span>
                </v-btn>
              </router-link>
            </v-list-item>

            <v-list-item>
              <router-link class="" to="/Nosotros">
                <v-btn text @click="top">
                  <span class="title">Nosotros</span>
                </v-btn>
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link class="" to="/Info">
                <v-btn text @click="top">
                  <span class="title">Investigación</span>
                </v-btn>
              </router-link>
            </v-list-item>
            <v-list-item>
              <router-link class="" to="/App-kefuri">
                <v-btn text @click="top">
                  <span class="title">App</span>
                </v-btn>
              </router-link>
            </v-list-item>
            <v-list-item class="pl-8">
              <v-btn color="cyan" class=" btn-contact" href="/#contact">
              Contáctanos
              </v-btn>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-navigation-drawer>
</div>

    

</template>

<script>
export default {
    name: 'Header',
    props: [],
    data() {
        return {
            drawer: false
        }
    },
    methods: {
      top () {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }
    }
}
</script>

<style scoped lang="sass">
@import "../sass/variables.sass"

.menu-xs
  display: block
        
  +for-tablet-portrait-up
    display: none

.link-menu
  display: none
  
  +for-tablet-portrait-up
    display: block
    text-decoration: none

.btn-contact
  color: $white !important   

.bg-menu-xs
  background: url('../assets/img/bg-menu-xs.png') 
  background-size: cover
</style>